module.exports = __webpack_public_path__ + "img/num_29.088f5166.png";